import React from 'react'
import { CarouselNew, StoreCard } from 'components'
import { CartCarouselArrow } from '../cart-carousel-arrow'
import './style.scss'

export function CartRecommendations({ products = [], onAddItem }) {
  function renderRecommendationCard(product) {
    return <StoreCard key={product.familyName} product={product} onAddItem={onAddItem} />
  }

  function renderContent() {
    return (
      <div className='cart-recommendations'>
        <div className='title'>Você pode gostar</div>
        <div className='recommendations-carousel'>
          <CarouselNew
            variableWidth
            align='start'
            customArrowComponent={CartCarouselArrow}
            gap='8px'
          >
            {products.map(renderRecommendationCard)}
          </CarouselNew>
        </div>
      </div>
    )
  }

  return products.length > 0 ? renderContent() : null
}
